module.exports = __webpack_public_path__ + "static/media/undraw_pleasant_surprise_5sjy 1.6907fcc2.svg";